<template>
  <page-header-wrapper>
    <a-card :bordered="false">
      <div class="table-page-search-wrapper">
        <a-form layout="inline">
          <div class="ant-pro-page-header-search">
            <a-input-search
              size="large"
              style="width: 80%; max-width: 522px"
              v-model="params.where.title"
              placeholder="请输入名称"
              enter-button
              allow-clear
              @search="getLists()"
            />
          </div>
        </a-form>
      </div>
    </a-card>
    <a-card style="margin-top: 24px" :bordered="false" title="广告位列表">
      <div slot="extra" class="d-flex align-items-center">
        <table-tool-bar-list
          :columns="settingColumns"
          :element="element"
          @change="toolBarChange"
          @reload="getLists()"
        />
        <a-radio-group @change="searchChangeState" style="margin-left:1rem">
          <a-radio-button value="0">全部</a-radio-button>
          <a-radio-button value="1">展示</a-radio-button>
          <a-radio-button value="2">隐藏</a-radio-button>
        </a-radio-group>
      </div>
      <a-form :form="form" layout="inline" style="margin-bottom:15px;background:#f0f2f5;padding:15px">
        <a-form-item label="标题">
          <a-input v-decorator="['title', { rules: [{ required: true, message: '请输入广告名称' }] }]" />
        </a-form-item>
        <a-form-item label="标识">
          <a-input
            v-decorator="['unique_title', { rules: [{ required: true, message: '请输入广告标识' }] }]"
          />
        </a-form-item>
        <a-form-item label="状态">
          <a-switch
            checked-children="展示"
            un-checked-children="隐藏"
            name="state"
            v-decorator="[
              'state',
              {
                valuePropName: 'checked',
                initialValue: true
              }
            ]"
          />
        </a-form-item>
        <a-form-item>
          <a-button type="primary" v-action:add @click="handleSubmitForm" icon="plus">
            添加
          </a-button>
        </a-form-item>
      </a-form>
      <a-table
        class="screenfull"
        :columns="columns"
        :data-source="list"
        :rowKey="record => record.id"
        :pagination="pagination"
        :loading="loading"
        :size="size"
        :bordered="false"
      >
        <template
          v-for="col in ['name', 'unique_title', 'order']"
          :slot="col"
          slot-scope="text, record, index, expanded"
        >
          <div :key="col">
            <a-input
              v-if="record.editable"
              style="margin: -5px 0"
              :value="text"
              @change="e => handleChange(e.target.value, record.id, expanded)"
            />
            <template v-else>
              {{ text }}
            </template>
          </div>
        </template>
        <template slot="state" slot-scope="text, record">
          <a-switch
            default-checked
            v-action:state
            :checked="record.state === 1"
            @change="handleChangeState(record.id)"
          >
            <a-icon slot="checkedChildren" type="check" />
            <a-icon slot="unCheckedChildren" type="close" />
          </a-switch>
        </template>
        <template slot="operation" slot-scope="text, record">
          <div class="editable-row-operations">
            <span v-if="record.editable" v-action:update>
              <a @click="() => handleSave(record.id)"><a-icon type="check" /> 保存</a>
              <a @click="() => handleCancel(record.id)"><a-icon type="close" /> 取消</a>
            </span>
            <span v-else>
              <a @click="() => handleEdit(record.id)" v-action:update><a-icon type="edit" /> 编辑</a>
            </span>
            <a-divider type="vertical" />
            <a-popconfirm
              v-if="list.length"
              title="确定要删除吗？"
              @confirm="() => handleOnDelete(record.id)"
              v-action:delete
            >
              <a href="javascript:;"><a-icon type="delete" /> 删除</a>
            </a-popconfirm>
          </div>
        </template>
      </a-table>
    </a-card>
  </page-header-wrapper>
</template>

<script>
import { table, list, category } from '@/mixins' // 引入
import { TableToolBarList } from '@/components'
const fields = ['title', 'unique_title', 'order']
const apiList = {
    getList: '/ads/places',
    changeState: '/ads/places/',
    delete: '/ads/places/',
    create: '/ads/places/create',
    update: '/ads/places/'
}
const columns = [
    {
        title: 'ID',
        dataIndex: 'id',
        sorter: true
    },
    {
        title: '标题',
        dataIndex: 'title',
        scopedSlots: { customRender: 'name' },
        ellipsis: true
    },
    {
        title: '标识',
        dataIndex: 'unique_title',
        scopedSlots: { customRender: 'unique_title' },
        ellipsis: true
    },
    {
        title: '状态',
        dataIndex: 'state',
        scopedSlots: { customRender: 'state' }
    },
    {
        title: '操作',
        dataIndex: 'operation',
        scopedSlots: { customRender: 'operation' }
    }
]
export default {
    name: 'PlaceList',
    mixins: [table, list, category], // 使用mixins
    components: {
        TableToolBarList
    },
    data () {
        return {
            fields,
            apiList,
            columns, // 表头
            settingColumns: JSON.parse(JSON.stringify(columns)) // 深度复制表头
        }
    },
    mounted () {
        this.getLists()
    },
    methods: {

    }
}
</script>
